import React, { useState } from "react";
import DataTable from "../../../Components/UI/table/DataTable";
import { useQuery } from "react-query";
import StatusBadge from "../../../Components/UI/statusBadge";
import TableActions from "../../../Components/UI/table/TableActions";
import { deleteOffer, updateOffer } from "../../../MyApi/product/offers";
import { getAddProductSpecialOffer } from "../../../MyApi/product/offers";
import OfferModal from "../../../Components/product/show/offerModal";
import Can from "../../../utils/can";
import { formatPrice } from "../../../utils/formatPrice";
import i18next from "i18next";

const QuickOffersTab = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [offerModalMode, setOfferModalMode] = useState("create");
  const [offerId, setOfferId] = useState(null);
  const [isFlashOffer, setIsFlashOffer] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  const handleShowOffer = (id) => {
    setOfferId(id);
    setOfferModalMode("show");
    setIsFlashOffer(true);
    setIsModalOpen(true);
  };

  const handleEditOffer = (id) => {
    setOfferId(id);
    setOfferModalMode("edit");
    setIsFlashOffer(true);
    setIsModalOpen(true);
  };

  const quickOffersColumns = [
    { label: "كود المنتج", accessor: "offerable.barcode" },
    { label: " المنتج", accessor: "offerable.name" },
    { label: "المتجر", accessor: "offerable.store.name" },
    { label: "نوع الخصم", accessor: "discount_type" },
    {
      label: "سعر المنتج",
      render: (row) => (
        <div>{formatPrice(row.offerable?.currency_factor, row.offerable?.price)} {row.offerable?.currency_code}</div>
      )
    },
    { label: "الخصم", render:(row)=> <div className="text-green">{row.discount_amount} {row.discount_type ==="percentage" ?"%":""}</div> },
    {
      label: "السعر قبل",
      render: (row) => (
        <div>{formatPrice(row.offerable?.currency_factor, row.offerable?.price)} {row.offerable?.currency_code}</div>
      )
    },
    {
      label: "السعر بعد",
      render: (row) => (
        <div>{formatPrice(row.offerable?.currency_factor, row.offerable?.nearest_offer?.sale_price)} {row.offerable?.currency_code}</div>
      )
    },
    { label: "تاريخ البداية", accessor: "start_date" },
    { label: "تاريخ النهاية", accessor: "end_date" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          show={() => handleShowOffer(row.id)}
          viewPermission={"view_offer"}
          edit={() => handleEditOffer(row.id)}
          editPermission={"update_offer"}
          deleteFn={deleteOffer}
          deletePermission={"delete_offer"}
          id={row.id}
          queryKey={"getQuickOffers"}
          is_active={row.is_active}
          togglePermission={"update_offer"}
          toggleMutationKey={"toggle-update-offer"}
          toggleFn={(id, status) => updateOffer(id, {
            is_active: status,
            _method: "PUT",
            lang: i18next.language
          })}
        />
      ),
    },
  ];

  const {
    data: quickOffersData,
    isLoading: quickLoading,
    refetch,
    error,
  } = useQuery(["getQuickOffers", currentPage], () =>
    getAddProductSpecialOffer(true, currentPage)
  );

  const quickOffers = quickOffersData?.data?.offers || [];
  const total = quickOffersData?.data?.pagination?.total || 0;
  const last_page = quickOffersData?.data?.pagination?.last_page || 0;

  return (
    <>
      <Can permission={"view_offer"}>
        <DataTable
          columns={quickOffersColumns}
          data={quickOffers}
          title="العروض السريعة"
          actionLabel="إضافة عرض سريع"
          onAddClick={() => {
            setOfferModalMode("create");
            setOfferId(null);
            setIsFlashOffer(true);
            setIsModalOpen(true);
          }}
          isLoading={quickLoading}
          createPermission={"create_offer"}
          totalItems={total}
          itemsPerPage={last_page}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          error={error}
          onRetry={() => refetch()}
        />
      </Can>
      <OfferModal
        isModalOpen={isModalOpen}
        is_flash_sale={true}
        isStore={true}
        refetch={refetch}
        closeModal={() => {
          setIsModalOpen(false);
          setOfferModalMode("create");
          setOfferId(null);
        }}
        mode={offerModalMode}
        offerId={offerId}
      />
    </>
  );
};

export default QuickOffersTab;
